import { useAppStore } from '@/store'
import { DirectiveBinding } from 'vue'

/**
 * <div v-perm.department-add></div>
 * <div v-perm.department-add.department-edit></div>
 * <div v-perm="'department-add'"></div>
 * <div v-perm="'department-add||department-edit&&department-view'"></div>
 */
const perm = (el: HTMLElement, binding: DirectiveBinding) => {
  const { authList } = useAppStore()

  function logicalOperation (list: string[], isAnd: boolean):boolean {
    return list.reduce((pre, current) => {
      const result = authList.includes(current.trim())
      return isAnd ? (pre && result) : (pre || result)
    }, isAnd)
  }

  let orList
  if (Object.keys(binding.modifiers || {})?.length) {
    orList = Object.keys(binding.modifiers)
  } else {
    orList = binding.value.split('||')
  }
  for (let i = 0; i < orList.length; i++) {
    const element = orList[i]
    const inList = element.split('&&')
    if (inList.length > 1) {
      const result = logicalOperation(inList, true)
      orList.splice(i, 1, result)
    }
  }
  const result = logicalOperation(orList, false)

  if (!result) {
    if (el.parentNode) {
      el.parentNode.removeChild(el)
    }
  }
}

perm.directiveName = 'perm'

export default perm
